import React, { useState, useRef, useEffect } from 'react';
import auditDrop from '../../../images/icons/auditDrop.svg';
import tikAudit from '../../../images/icons/tikAudit.svg';
import CommonCheckbox from '../../../common/components/CommonCheckBox/CommonCheckbox';
import moment from 'moment';
import DashboardTimeFilter from '../../../components/DashboardDateFilter/DashboardDateFilter';
import * as _ from 'lodash';

const filterMenu = [
  {
    name: 'Date',
    type: 'link',
    dropdown: [
      {
        title: 'Today'
      },
      {
        title: 'Yesterday'
      },
      {
        title: 'Last 7 days'
      },
      {
        title: 'Last week'
      },
      {
        title: 'Last 30 days'
      },
      {
        title: 'This Month'
      },
      {
        title: 'Last Month'
      },
      {
        title: 'Custom'
      }
    ]
  },

  {
    name: 'Activity',
    type: 'check',
    dropdown: [
      {
        title: 'All'
      },
      {
        title: 'Lead Generated'
      },
      {
        title: 'Applicants Added'
      },
      {
        title: 'Document Uploaded'
      },
      {
        title: 'Document OCR Success'
      },
      {
        title: 'Document OCR Failed'
      },
      {
        title: 'Data Updated'
      },
      {
        title: 'Data Verification Success'
      },
      {
        title: 'Data Verification Failed'
      },
      {
        title: 'Lead Status Changed'
      }
    ]
  }
  /*
  {
    name: 'User Type',
    type: 'check',
    dropdown: [
      {
        title: 'RM'
      },
      {
        title: 'BP'
      },
      {
        title: 'CM'
      }
    ]
  }
  */
];
const FilterOptions = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  userType,
  setUserType,
  activityValues,
  setActivityValues,
  setShowOptions,
  lastHighlightedTimeLine,
  setLastHighlightedTimeLine,
  HighlightedText,
  setHighlightedText,
  flexTimeLine,
  setFlexTimeLine,
  onClikFilter,
  removeFilter
}) => {
  const linkRef = useRef([]);
  const myRefs = useRef([]);
  const [selectedTimeLine, setSelectedTimeLine] = useState(
    lastHighlightedTimeLine
  );
  const [toggleDateOptions, setToggleDateOptions] = useState(false);

  const Obj2ArrActivity = Object.keys(activityValues);
  const Obj2ArrUserType = Object.keys(userType);

  useEffect(() => {
    try {
      if (flexTimeLine === true) {
        myRefs.current[0].style.display = 'flex';
      }
      if (!Object.keys(activityValues).every(k => !activityValues[k])) {
        myRefs.current[1].style.display = 'flex';
        setFlexTimeLine(true);
      }
      if (!Object.keys(userType).every(k => !userType[k])) {
        myRefs.current[2].style.display = 'flex';
        setFlexTimeLine(true);
      }
    } catch {}
  }, [flexTimeLine, userType, activityValues]);

  const resetHandler = () => {
    setActivityValues({
      all: false,
      uploaded: false,
      added: false,
      edited: false,
      deleted: false
    });
    setUserType({
      rm: false,
      bp: false,
      cm: false
    });
    timeLineSetter(0);
    removeFilter();
  };

  const applyHandler = async () => {
    await setShowOptions(false);
    let filterData = {};
    filterData['startDate'] = startDate;
    filterData['endDate'] = endDate;
    filterData['activityValues'] = activityValues;
    onClikFilter(filterData);
  };

  const timeLineSetter = i => {
    setLastHighlightedTimeLine(i);
    setSelectedTimeLine(i);
    if (i === 7) {
      setFlexTimeLine(false);
      setToggleDateOptions(true);
    } else {
      setFlexTimeLine(true);
    }
    switch (i) {
      // today
      case 0: {
        setHighlightedText('TODAY');
        setStartDate(moment().format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        return;
      }
      // yesterday
      case 1: {
        setHighlightedText('YESTERDAY');
        setStartDate(
          moment()
            .subtract(1, 'd')
            .format('YYYY-MM-DD')
        );
        setEndDate(
          moment()
            .subtract(1, 'd')
            .format('YYYY-MM-DD')
        );
        return;
      }
      // last 7 days
      case 2: {
        setHighlightedText('LAST 7 DAYS');

        setStartDate(
          moment()
            .subtract(6, 'd')
            .format('YYYY-MM-DD')
        );
        setEndDate(moment().format('YYYY-MM-DD'));
        return;
      }
      // last week
      case 3: {
        setHighlightedText('LAST WEEK');
        setStartDate(
          moment()
            .subtract('weeks', 1)
            .day(1)
            .startOf('day')
            .format('YYYY-MM-DD')
        );
        setEndDate(
          moment()
            .subtract('weeks', 1)
            .day(7)
            .endOf('day')
            .format('YYYY-MM-DD')
        );
        return;
      }
      //last 30days
      case 4: {
        setHighlightedText('LAST 30 DAYS');
        setStartDate(
          moment()
            .subtract(29, 'd')
            .format('YYYY-MM-DD')
        );
        setEndDate(moment().format('YYYY-MM-DD'));

        return;
      }
      // this month
      case 5: {
        setHighlightedText('THIS MONTH');
        setStartDate(
          moment()
            .startOf('month')
            .format('YYYY-MM-DD')
        );
        setEndDate(moment().format('YYYY-MM-DD'));
        return;
      }
      //last month
      case 6: {
        setHighlightedText('LAST MONTH');

        setStartDate(
          moment()
            .subtract(1, 'months')
            .startOf('month')
            .format('YYYY-MM-DD')
        );
        setEndDate(
          moment()
            .subtract(1, 'months')
            .endOf('month')
            .format('YYYY-MM-DD')
        );
        return;
      }
      // CUSTOM
      case 7: {
        setHighlightedText('CUSTOM');
        setStartDate(moment().format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
        return;
      }
      default: {
        setStartDate(moment().format('YYYY-MM-DD'));
        setEndDate(moment().format('YYYY-MM-DD'));
      }
    }
  };

  return toggleDateOptions ? (
    <div onClick={e => e.stopPropagation()}>
      <DashboardTimeFilter
        vertical
        focusedInputProp
        setFlexTimeLine={setFlexTimeLine}
        setToggleDateOptions={setToggleDateOptions}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        startDate={startDate}
        endDate={endDate}
      />
    </div>
  ) : (
    <div
      className="md:w-81 w-full bg-black-1003 absolute z-50 md:-ml-57  -mr-3 mt-11 self-start pb-5  overflow-auto  "
      style={{ maxHeight: '85vh' }}
      onClick={e => e.stopPropagation()}
    >
      <ul className="p-3 flex flex-col justify-between space-y-4   ">
        {filterMenu.map(({ name, type, dropdown }, i) => (
          <li
            key={i}
            ref={el => (linkRef.current[i] = el)}
            className="text-blue-1102   "
          >
            <div
              className="flex flex-row justify-between pr-6 "
              onClick={() => {
                if (myRefs.current[i].style.display === 'flex')
                  myRefs.current[i].style.display = 'none';
                else {
                  myRefs.current[i].style.display = 'flex';
                }
              }}
            >
              <p>{name}</p>
              <img src={auditDrop} className="transform rotate-180 " alt="^" />
            </div>

            {dropdown && dropdown.length ? (
              <>
                <ul
                  style={{ display: 'none ' }}
                  className={'flex flex-col justify-between space-y-3 pt-3'}
                  ref={el => (myRefs.current[i] = el)}
                >
                  {type === 'link' ? (
                    // highlight text for TimeLine
                    <div className="mt-1">
                      <p className="text-grey-2221 text-sm">
                        {HighlightedText}
                      </p>
                      <p className=" text-grey-2221 text-sm">
                        {moment(startDate).format('DD MMM, YYYY')} -{' '}
                        {moment(endDate).format('DD MMM, YYYY')}
                      </p>
                      <hr className="w-11/12 mx-auto mt-3 text-black-400 " />
                    </div>
                  ) : null}

                  {dropdown.map(({ title }, i) => {
                    if (type === 'link') {
                      return (
                        <li
                          key={i}
                          className="flex flex-row justify-between pr-6 "
                          onClick={e => {
                            timeLineSetter(i);
                            e.stopPropagation();
                          }}
                        >
                          <p
                            className={
                              (selectedTimeLine === i
                                ? 'text-blue-1101 text-sm '
                                : '') + ' text-grey-2221 text-sm'
                            }
                          >
                            {title}
                          </p>
                          {selectedTimeLine === i ? (
                            <img src={tikAudit} alt="\/" />
                          ) : null}
                        </li>
                      );
                    }

                    if (type === 'check' && name === 'Activity') {
                      return (
                        <li key={i} className=" flex flex-row justify-between">
                          <p className="text-grey-2221 text-sm">{title}</p>
                          <CommonCheckbox
                            checked={
                              activityValues[Obj2ArrActivity[i]] || false
                            }
                            name="activity"
                            value={activityValues[Obj2ArrActivity[i]]}
                            onChange={e => {
                              let temp = Object.assign({}, activityValues);
                              temp = _.mapValues(temp, () => false);
                              let temp1 = Obj2ArrActivity[i];
                              temp[temp1] = e.target.checked;
                              setActivityValues(temp);
                              setFlexTimeLine(true);
                            }}
                            // onBlur={handleBlur}
                          />
                        </li>
                      );
                    }
                    if (type === 'check' && name === 'User Type') {
                      return (
                        <li key={i} className=" flex flex-row justify-between">
                          <p className="text-grey-2221 text-sm">{title}</p>
                          <CommonCheckbox
                            checked={userType[Obj2ArrUserType[i]] || false}
                            name="userType"
                            value={userType[Obj2ArrUserType[i]]}
                            onChange={e => {
                              let temp = Object.assign({}, userType);
                              let temp1 = Obj2ArrUserType[i];
                              temp[temp1] = e.target.checked;
                              setUserType(temp);
                              setFlexTimeLine(true);
                            }}
                            // onBlur={handleBlur}
                          />
                        </li>
                      );
                    }
                  })}
                </ul>
              </>
            ) : null}
          </li>
        ))}
      </ul>
      {flexTimeLine ? (
        <div className="self-end flex flex-row w-48 ml-auto mr-3">
          <button
            className="block text-sm mx-auto  leading-none py-3 px-4 rounded mt-8  text-white h-10 w-22 bg-red-500"
            onClick={resetHandler}
          >
            Reset
          </button>

          <button
            onClick={applyHandler}
            className="block text-sm mx-auto  leading-none py-3 px-4 rounded mt-8  text-white h-10 w-22 bg-teal "
          >
            Apply
          </button>
        </div>
      ) : null}
    </div>
  );
};

export default React.memo(FilterOptions);
